// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2cdhQ","header":"ReportDetails_header__2AyR7","title":"ReportDetails_title__1Fbxh","left":"ReportDetails_left__2c1gz"};